import {
  adminClient,
  inferAdditionalFields,
  twoFactorClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { router } from "@/App";
import type { auth } from "../../../server/src/auth";
import { env } from "../../env";

export const authClient = createAuthClient({
  baseURL: env.VITE_SERVER_BASE_URL,
  fetchOptions: {
    credentials: "include",
  },
  plugins: [
    twoFactorClient({
      onTwoFactorRedirect() {
        // Preserve search parameters from current location when redirecting to 2FA
        const currentSearch = router.state.location.search;
        router.navigate({
          search: currentSearch,
          to: "/login/2fa",
        });
      },
    }),
    inferAdditionalFields<typeof auth>(),
    adminClient(),
  ],
});
